// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__YU5KL","container--disabled":"checkbox_container--disabled__SH40W","switch":"checkbox_switch__tTa44"};